import {format, parse} from 'date-fns';

export function toQueryString(object: any): string {
    const flattenedObject = flattenObject(object);
    const queryString = Object.keys(flattenedObject)
        .filter((key) => flattenedObject[key] !== null && flattenedObject[key] !== undefined)
        .map((key) => {
            const value = prepareValueForUrl(flattenedObject[key]);
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .join('&');
    return queryString;
}

export function toSearchParams(object: any): Array<[string, string]> {
    const flattenedObject = flattenObject(object);
    const searchParams = Object.keys(flattenedObject)
        .filter((key) => flattenedObject[key] !== null && flattenedObject[key] !== undefined)
        .map((key) => {
            const value = prepareValueForUrl(flattenedObject[key]);
            return [String(key), String(value)];
        });

    return searchParams as Array<[string, string]>;
}

export function fromQueryString(queryString: string): object {
    if (queryString === '') {
        return {};
    }
    const object = queryString
        .split('&')
        .map((pair) => pair.split('='))
        .reduce((acc, [key, value]) => {
            return {
                ...acc,
                [key]: revertValueFromUrl(value),
            };
        }, {});
    return unflattenObject(object);
}

export function fromSearchParams(searchParams: URLSearchParams): object {
    const object = Array.from(searchParams.entries()).reduce((acc, [key, value]) => {
        return {
            ...acc,
            [key]: revertValueFromUrl(value),
        };
    }, {});
    return unflattenObject(object);
}

function prepareValueForUrl(value: any): string {
    if (value instanceof Date) {
        return 'date.' + format(value, 'yyyy-MM-dd');
    }
    return value;
}

function revertValueFromUrl(value: any): any {
    if (typeof value === 'string' && value.startsWith('date.')) {
        try {
            let date = parse(value.substring('date.'.length), 'yyyy-MM-dd HH:mm:ss', new Date());
            if (String(date) === 'Invalid Date') {
                date = parse(value.substring('date.'.length), 'yyyy-MM-dd', new Date());
                if (String(date) === 'Invalid Date') {
                    return null;
                }
            }
            return date;
        } catch (e) {
            return null;
        }
    }
    return value;
}

function flattenObject(ob: any, prefix: string | null = null, result: any = null) {
    result = result || {};

    // Preserve empty objects and arrays, they are lost otherwise
    if (prefix && typeof ob === 'object' && ob !== null && Object.keys(ob).length === 0) {
        result[prefix] = Array.isArray(ob) ? [] : {};
        return result;
    }

    prefix = prefix ? prefix + '.' : '';

    for (const i in ob) {
        if (Object.prototype.hasOwnProperty.call(ob, i)) {
            // Only recurse on true objects and arrays, ignore custom classes like dates
            if (
                typeof ob[i] === 'object' &&
                (Array.isArray(ob[i]) || Object.prototype.toString.call(ob[i]) === '[object Object]') &&
                ob[i] !== null
            ) {
                // Recursion on deeper objects
                flattenObject(ob[i], prefix + i, result);
            } else {
                result[prefix + i] = ob[i];
            }
        }
    }
    return result;
}

function unflattenObject(ob: any): any {
    const result = {};
    for (const i in ob) {
        if (Object.prototype.hasOwnProperty.call(ob, i)) {
            const keys: any = i.match(/(?:^\.+)?(?:\.{2,}|[^.])+(?:\.+$)?/g); // Just a complicated regex to only match a single dot in the middle of the string
            keys.reduce((r: any, e: any, j: any) => {
                return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? ob[i] : {}) : []);
            }, result);
        }
    }
    return result;
}
